(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../array', '../collection', '../lang', '../math', '../object', '../string', 'lodash/concat', 'lodash/flow', 'lodash/mapValues', 'lodash/toPath'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../array'), require('../collection'), require('../lang'), require('../math'), require('../object'), require('../string'), require('lodash/concat'), require('lodash/flow'), require('lodash/mapValues'), require('lodash/toPath'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.array, global.collection, global.lang, global.math, global.object, global.string, global.concat, global.flow, global.mapValues, global.toPath);
    global.ChainWrapper = mod.exports;
  }
})(this, function (exports, _array, _collection, _lang, _math, _object, _string, _concat, _flow, _mapValues, _toPath) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.ChainWrapper = undefined;

  var array = _interopRequireWildcard(_array);

  var collection = _interopRequireWildcard(_collection);

  var lang = _interopRequireWildcard(_lang);

  var math = _interopRequireWildcard(_math);

  var object = _interopRequireWildcard(_object);

  var string = _interopRequireWildcard(_string);

  var _concat2 = _interopRequireDefault(_concat);

  var _flow2 = _interopRequireDefault(_flow);

  var _mapValues2 = _interopRequireDefault(_mapValues);

  var _toPath2 = _interopRequireDefault(_toPath);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var ChainWrapper = function () {

    /**
     * This constructor should not be called directly.<br/>
     * Instances are created by calling {@link seq.chain}.
     * @param {Object} wrapped The object to wrap.
     * @param {Array|string} [path] The path of the object on which functions are called.
     * @param {Array} [pFlow=[]] Current calls flow.
     * @see {@link seq.chain} for more information.
     * @since 0.1.8
     */
    function ChainWrapper(wrapped, path) {
      var pFlow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      _classCallCheck(this, ChainWrapper);

      this._wrapped = wrapped;
      this._path = path;
      this._flow = pFlow;
      this._commited = null;
    }

    /**
     * Translates a relative path to an absolute path, using <code>this._path</code> as a base path.
     * @param {Array|string} path A relative path.
     * @return {Array} Absolute path.
     * @since 0.1.11
     */


    _createClass(ChainWrapper, [{
      key: '_absolutePath',
      value: function _absolutePath(path) {
        return (0, _concat2.default)((0, _toPath2.default)(this._path), (0, _toPath2.default)(path));
      }
    }, {
      key: '_call',
      value: function _call(fn, path, args) {
        var _this = this;

        return new ChainWrapper(this._wrapped, this._path, (0, _concat2.default)(this._flow, function (object) {
          return fn.apply(undefined, [object, _this._absolutePath(path)].concat(_toConsumableArray(args)));
        }));
      }
    }, {
      key: 'commit',
      value: function commit() {
        if (this._flow.length === 0) return this;

        if (this._commited === null) this._commited = new ChainWrapper((0, _flow2.default)(this._flow)(this._wrapped), this._path);

        return this._commited;
      }
    }, {
      key: 'peek',
      value: function peek(callback) {
        var commited = this.commit();

        callback(commited._wrapped);

        return commited;
      }
    }, {
      key: 'value',
      value: function value() {
        return this.commit()._wrapped;
      }
    }]);

    return ChainWrapper;
  }();

  /**
   * Function to be called by {@link seq.peek|peek} with the resolved unwrapped value.
   * @memberof seq
   * @callback peekCallback
   * @param {Object} unwrapped The resolved unwrapped object
   * @since 0.3.0
   */

  // Add namespaces functions to the ChainWrapper prototype
  [array, collection, lang, math, object, string].forEach(function (namespace) {
    return Object.assign(ChainWrapper.prototype, (0, _mapValues2.default)(namespace, function (fn) {
      return function (path) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return this._call(fn, path, args); // eslint-disable-line no-invalid-this
      };
    }));
  });

  exports.ChainWrapper = ChainWrapper;
  exports.default = ChainWrapper;
});